import React, { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Button } from "../ui/button";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem("ngl_install_dismissed")) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    // iOS Safari : pas d'événement -> afficher les instructions
    if (isIOS()) {
      setShow(true);
      setIosHint(true);
    }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("ngl_install_dismissed", "1");
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-3 inset-x-3 z-50 max-w-md mx-auto" data-testid="install-prompt">
      <div className="bg-white shadow-2xl rounded-xl border border-slate-200 p-3 flex items-center gap-3">
        <img src="/icon-192.png" alt="NGL" className="w-11 h-11 rounded-lg flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-800">Installer NGL Interventions</p>
          {iosHint ? (
            <p className="text-xs text-muted-foreground flex items-center gap-1">
              Appuyez sur <Share className="w-3 h-3 inline" /> puis « Sur l'écran d'accueil »
            </p>
          ) : (
            <p className="text-xs text-muted-foreground">Accès rapide plein écran, comme une vraie app.</p>
          )}
        </div>
        {!iosHint && (
          <Button size="sm" className="btn-primary" onClick={install} data-testid="install-app-button">
            <Download className="w-4 h-4 mr-1" /> Installer
          </Button>
        )}
        <button onClick={dismiss} className="text-slate-400 hover:text-slate-600" data-testid="install-dismiss" aria-label="Fermer">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
